// コンテンツ幅の半分とクリックされた要素の位置と幅を比較し、詳細を表示する場所を判定する
export const getDetailPosition = (
  contentWidth: number, // content-component要素幅
  selfWidth: number, // クリック対象のセンサ要素の幅
  selfClientX: number // クリックしたセンサのX座標
): string => {
  const rightflag = contentWidth - selfClientX - selfWidth > 300;
  return rightflag ? "right-detail" : "left-detail";
};
